import React, { useState, useEffect } from "react";
import {
  Form,
  Input,
  Upload,
  Button,
  message,
  Typography,
  Row,
  Col,
  Spin,
  Tooltip,
  Modal,
  InputNumber,
  Radio,
  Checkbox,
  notification,
  Divider,
  DatePicker
} from "antd";
import {
  UploadOutlined,
  DownloadOutlined,
  CheckCircleOutlined,
  CloseCircleOutlined,
  ExclamationCircleOutlined,
  LeftOutlined,
  RightOutlined,
  ArrowRightOutlined,
  ArrowLeftOutlined,
  DeleteOutlined,
  PaperClipOutlined
} from "@ant-design/icons";
import LeftLayout from "../pageHeader/LeftLayout";
import _NewapplicationService from "../../modules/NewapplicationService";
import { useHistory, useLocation } from "react-router-dom";
import { ALL_FIELDS_REQUIRED_MSG, API_HOST, APP_BLOB_ROOT, COMMON_ERROR_MSG } from "../../constants/constants";
import { routes } from "../../routes/Routes";
import IntegerInput from "../../components/IntergerInput";
import ShowApplicationId from "../NewApplication/ShowApplicationId";
import ApplicationProgressBar from "./ApplicationProgressBar";
import "./DocumentUpload.scss";
import ButtonComponent from "../../components/Button/Button";
const { Title, Text } = Typography;
const { confirm } = Modal;

const fileFormatText = (
  <Text type="secondary" style={{ fontSize: 12, marginLeft: 15 }}>
    Format: pdf, xls, xlsx &nbsp;&nbsp; Size: 155k-350k
  </Text>
);

const UploadDocumentsOne = () => {
  const [form] = Form.useForm();
  const [signatureForm] = Form.useForm();
  const applicationId = localStorage.getItem("ApplicationId");
  const history = useHistory();
  const [loading, setLoading] = useState(false);
  const [uploading, setUploading] = useState(false);
  const [applicantInfo, setApplicantInfo] = useState({});
  const [applInfo, setApplInfo] = useState({});
  const [fileUrls, setFileUrls] = useState({});
  const [fileList, setFileList] = useState({});
  const [multiFileList, setMultiFileList] = useState({
    updoccapitalaccountstatements: [],
    updocliquiditystatements: [],
    patriotApplicant: [],
    patriotCoBorrower: [],
    taxReturn: [],
  });

  const [multiFilePaths, setMultiFilePaths] = useState({
    updoccapitalaccountstatements: [],
    updocliquiditystatements: [],
    patriotApplicant: [],
    patriotCoBorrower: [],
    taxReturn: [],
  });

  const rowIdRef = React.useRef(1);
  const getNextRowId = () => rowIdRef.current++;

  const getMaxRowIdFromUrls = (urls = []) => {
    let maxRowId = 0;

    urls.forEach((url) => {
      try {
        const fileName = url
          .split("?")[0]
          .split("/")
          .pop();

        // 10029_3.pdf => 3
        const match = fileName.match(/_(\d+)\.[^.]+$/);

        if (match) {
          maxRowId = Math.max(maxRowId, Number(match[1]));
        }
      } catch (e) {
        console.log(e);
      }
    });

    return maxRowId;
  };

  const FIELD_LABELS = {
    personalFinancial: "Personal Financial Statement",
    patriotApplicant: "Patriot Act Form (Client)",
    patriotCoBorrower: "Patriot Act Form (Co-Borrower)",
    creditBureau: "Credit Bureau Report",
    creditBureauCoBorrower: "Credit Bureau Report (Co-Borrower)",
    taxReturn: "First Two Pages Of Personal Tax Return",
    updoccapitalaccountstatements: "Capital Account Statements",
    updocliquiditystatements: "Liquidity Statements",
  };

  let APPLICATION_TYPE_ID = localStorage.getItem("applicationTypeId");
  const location = useLocation();
  let data = location.state;
  let applnObjId = "";
  let activeKeyTab = null;
  let fromDashboard = false;

  if (data && data.applicationObjId) {
    applnObjId = data.applicationObjId;
  }
  if (data && data.isFromDashboard) {
    fromDashboard = data.isFromDashboard;
  }
  if (data && data.activeKey) {
    activeKeyTab = data.activeKey;
  }

  const [appObjId] = useState(applnObjId);
  const [isFromDashboard] = useState(fromDashboard);
  const [tabActiveKey] = useState(activeKeyTab);
  const [isSignatureModalOpen, setIsSignatureModalOpen] = useState(false);
  const [pfsMethod, setPfsMethod] = useState(null);
  const [apiPfsMethod, setApiPfsMethod] = useState(null);
  const [apiPfsMethodLable, setApiPfsMethodLable] = useState(null);
  const [thirdpartyProvider, setThirdPartyProvider] = useState(null);
  const [preUploadedPfsUrl, setPreUploadedPfsUrl] = useState(`${API_HOST}/TempImages/BlankPFS/AppBlankPFS.pdf`);
  const [patriotActDownloadUrl, setPatriotActDownloadUrl] = useState(" ");
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  useEffect(() => {
    getApplicantDetailsByID();
  }, []);

  useEffect(() => {
    fetchPrepopulatedPatriotActPdf();
  }, []);

  useEffect(() => form.resetFields(), [applicantInfo]);

  const validateFile = (file) => {
    const isValidType = [
      "application/pdf",
      "application/vnd.ms-excel", // .xls
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" // .xlsx
    ].includes(file.type);

    // const isGt155KB = file.size >= 155 * 1024;
    // const isLt350KB = file.size <= 350 * 1024;

    // Maximum size: 25MB
    const isLt4MB = file.size <= 25 * 1024 * 1024;

    if (!isValidType) {
      message.error("Only PDF/XLS/XLSX files are allowed!");
      return false;
    }
    // if (!isGt155KB || !isLt350KB) {
    //   message.error("File size must be between 155KB and 350KB!");
    //   return false;
    // }

    if (!isLt4MB) {
      message.error("File size must be up to 25MB!");
      return false;
    }

    return true;
  };

  const handleUpload = (field, docType, label) => async (file) => {
    if (!validateFile(file)) return Upload.LIST_IGNORE;

    const formData = new FormData();
    formData.append("files[]", file);
    const ApplicationId = localStorage.getItem("Id");

    setUploading(true);
    try {
      const res = await _NewapplicationService.UploadPdfOrDocFile(
        formData,
        ApplicationId,
        docType
      );

      if (res?.data?.IsSucess && res?.data?.URL) {
        setUploading(false);
        const relativePath = new URL(res.data.URL).pathname;
        form.setFieldsValue({ [field]: relativePath });

        setApplicantInfo((prev) => ({
          ...prev,
          [field]: relativePath,
        }));

        setFileUrls((prev) => ({
          ...prev,
          [field]: res.data.URL,
        }));

        setFileList((prev) => ({
          ...prev,
          [field]: [
            {
              uid: "-1",
              name: label,
              status: "done",
              url: res.data.URL,
              type: file.type,
            },
          ],
        }));

        // notification.success({
        //   description: res?.data?.Message,
        //   icon: <CheckCircleOutlined style={{ color: "#52c41a" }} />,
        //   duration: 3,
        //   placement: "top",
        // });
        message.success(res?.data?.Message);
      } else {
        setUploading(false);
        // notification.error({
        //   message: "Upload Failed",
        //   description:
        //     res?.data?.Message || `${file.name} failed to upload.`,
        //   icon: <CloseCircleOutlined style={{ color: "#ff4d4f" }} />,
        //   duration: 3,
        //   placement: "top",
        // });
        message.error(res?.data?.Message || `${file.name} failed to upload.`,)
      }
    } catch (err) {
      setUploading(false);
      console.error("Upload error:", err);
    }

    return Upload.LIST_IGNORE;
  };

  const getRelativePath = (url = "") => {
    try {
      return new URL(url).pathname;
    } catch {
      return url;
    }
  };

  const handleMultiUpload =
    (field, docType) =>
      async (file) => {
        if (!validateFile(file)) {
          return Upload.LIST_IGNORE;
        }

        const rowId = getNextRowId();

        const formData = new FormData();
        formData.append("files[]", file);

        const ApplicationId = localStorage.getItem("Id");

        setUploading(true);

        try {
          const res = await _NewapplicationService.UploadPdfOrDocFileRowId(
            formData,
            ApplicationId,
            docType,
            rowId // unique integer > 0
          );

          if (res?.data?.IsSucess && res?.data?.URL) {
            const relativePath = new URL(res.data.URL).pathname;

            const uploadedItem = {
              uid: `${rowId}`,
              rowId,
              name: file.name,
              status: "done",
              url: res.data.URL,
              type: file.type,
              path: relativePath,
            };

            setMultiFileList((prev) => ({
              ...prev,
              [field]: [...(prev[field] || []), uploadedItem],
            }));

            setMultiFilePaths((prev) => {
              const updatedPaths = [...(prev[field] || []), relativePath];

              form.setFieldsValue({
                [field]: updatedPaths.join(","),
              });

              return {
                ...prev,
                [field]: updatedPaths,
              };
            });

            message.success(res?.data?.Message);
          } else {
            message.error(
              res?.data?.Message || `${file.name} failed to upload.`
            );
          }
        } catch (error) {
          console.error(error);
        } finally {
          setUploading(false);
        }

        return Upload.LIST_IGNORE;
      };

  const removeMultiFile = (field, file) => {
    setMultiFileList((prev) => ({
      ...prev,
      [field]: prev[field].filter((x) => x.uid !== file.uid),
    }));

    setMultiFilePaths((prev) => {

      const updatedPaths = prev[field].filter(
        (path) => path !== file.path
      );

      form.setFieldsValue({
        [field]: updatedPaths.join(","),
      });

      return {
        ...prev,
        [field]: updatedPaths,
      };
    });
  };

  const showDeleteConfirm = (field, label) => {
    confirm({
      title: `Are you sure you want to delete this ${label} file?`,
      icon: <ExclamationCircleOutlined />,
      okText: <span id="yesBtn">Yes</span>,
      cancelText: <span id="noBtn">No</span>,
      okType: "primary",
      onOk() {
        handleRemove(field);
      },
    });
  };

  const handleRemove = (field) => {
    setFileUrls((prev) => {
      const updated = { ...prev };
      delete updated[field];
      return updated;
    });

    setFileList((prev) => {
      const updated = { ...prev };
      delete updated[field];
      return updated;
    });

    setApplicantInfo((prev) => {
      const updated = { ...prev };
      delete updated[field];
      return updated;
    });

    form.setFieldsValue({ [field]: "" });
  };
  const clearUploadedField = (field) => {
    setFileList(prev => {
      const updated = { ...prev };
      delete updated[field];
      return updated;
    });

    setFileUrls(prev => {
      const updated = { ...prev };
      delete updated[field];
      return updated;
    });

    setApplicantInfo(prev => {
      const updated = { ...prev };
      delete updated[field];
      return updated;
    });

    form.setFields([
      { name: field, value: undefined, errors: [] }
    ]);
  };
  const clearFormField = (field) => {
    // clear AntD Form value
    form.setFields([
      {
        name: field,
        value: undefined,
        errors: [],
      },
    ]);

    // clear external state
    setApplicantInfo((prev) => ({
      ...prev,
      [field]: null,
    }));
  };
  const handlePfsMethodChange = (e) => {
    const value = e.target.value;
    clearUploadedField("levconspfs");
    // clearFormField("creditBureauScore");
    setPfsMethod(value);
    // if (value == "pdfupload") {
    //   createPrepopulatedPFS();
    // }
  };

  const getFileNameFromUrl = (url = "") => {
    try {
      const cleanUrl = url.split("?")[0];
      return cleanUrl.substring(cleanUrl.lastIndexOf("/") + 1);
    } catch {
      return "";
    }
  };

  const getUploadItem = (label, field, docType, isRequired = true) => {
    const currentFileList = fileList[field] || [];

    return (
      <Form.Item
        name={field}
        rules={isRequired ? [{ required: true, message: `${label} is required` }] : []}
        valuePropName="file"
        getValueFromEvent={() => applicantInfo[field]}
        className="upload-form-item"
      >
        <Upload
          className="uploadDivDoc1"
          accept=".pdf"
          beforeUpload={handleUpload(field, docType, label)}
          fileList={currentFileList}
          maxCount={1}
          onRemove={() => showDeleteConfirm(field, label)}
          customRequest={({ onSuccess }) => onSuccess("ok")}
          showUploadList={true}
        >
          {currentFileList.length === 0 && (
            <div className="upload-placeholder">
              <UploadOutlined />
              <span>Upload File</span>
            </div>
          )}
        </Upload>

        {/* <div className="upload-format-text">
          Format: pdf, xls, xlsx &nbsp;&nbsp; Size: 155k–350k
        </div> */}
      </Form.Item>
    );
  };

  const handleFileDownload = (file) => {
    const fileUrl =
      file.url?.startsWith("http")
        ? file.url
        : `${APP_BLOB_ROOT}${file.url}`;

    window.open(fileUrl, "_blank");
  };

  const getMultiUploadItem = (
    label,
    field,
    docType
  ) => {
    const currentFileList = multiFileList[field] || [];

    return (
      <Form.Item
        name={field}
        className="upload-form-item"
      >
        {/* Upload Button */}
        <Upload
          className="uploadDivDoc1"
          accept=".pdf,.xls,.xlsx"
          beforeUpload={handleMultiUpload(field, docType)}
          showUploadList={false}
          customRequest={({ onSuccess }) => onSuccess("ok")}
        >
          <div className="upload-placeholder">
            <UploadOutlined />
            <span>Upload File</span>
          </div>
        </Upload>

        { }
        {currentFileList.map((file) => (
          <div
            key={file.uid}
            className="uploadDivDoc1 mt10 deleteFileIcon"
          >
            <div className="upload-placeholder uploaded-file-row">
              <div className="currentFileCss">
                <PaperClipOutlined />

                <span
                  className="wordBreakWord fileNameColor currentFileIcon"
                  onClick={() => handleFileDownload(file)}
                >
                  {file.name}
                </span>
              </div>

              <DeleteOutlined
                className="currentDeleteIcon"
                onClick={() => {
                  Modal.confirm({
                    title: `Are you sure you want to delete this ${label} file?`,
                    icon: <ExclamationCircleOutlined />,
                    okText: "Yes",
                    cancelText: "No",
                    onOk() {
                      removeMultiFile(field, file);
                    },
                  });
                }}
              />
            </div>
          </div>
        ))}
      </Form.Item>
    );
  };

  const getUploadPFSItem = (label, field, docType, isRequired = true) => {
    const currentFileList = fileList[field] || [];

    return (
      <Form.Item
        name={field}
        rules={isRequired ? [{ required: true, message: `${label} is required` }] : []}
        valuePropName="file"
        getValueFromEvent={() => applicantInfo[field]}
        className="upload-form-item"
      >
        <Upload
          className="uploadDivDoc1"
          accept=".pdf"
          beforeUpload={handleUpload(field, docType, label)}
          fileList={currentFileList}
          maxCount={1}
          onRemove={() => showDeleteConfirm(field, label)}
          customRequest={({ onSuccess }) => onSuccess("ok")}
          showUploadList={true}
        >
          {currentFileList.length === 0 && (
            <div className="upload-placeholder">
              <UploadOutlined />
              <span>Upload File</span>
            </div>
          )}
        </Upload>

        {/* <div className="upload-format-text">
          Format: pdf, xls, xlsx &nbsp;&nbsp; Size: 155k–350k
        </div> */}
      </Form.Item>
    );
  };
  const getPathname = (url) => {
    try {
      return new URL(url).pathname;
    } catch {
      if (typeof url === "string" && url.startsWith("/")) {
        return url;
      }
      console.warn("Invalid URL passed to getPathname:", url);
      return ""; // fallback to empty string to avoid crashing
    }
  };

  const convertPTagsToBullets = (html) => {
    if (!html) return html;

    return `
    <ul style="padding-left: 20px; margin: 0;">
      ${html
        .replace(/<p>/g, '<li>')
        .replace(/<\/p>/g, '</li>')}
    </ul>
  `;
  };

  const getPayloadPaths = (paths = []) =>
    paths
      .map((path) => getRelativePath(path))
      .filter(Boolean)
      .join(",");

  const onFinish = async (values) => {
    let selectedApplicationFlow;
    if (pfsMethod == "pdfupload") {
      selectedApplicationFlow = "Upload";
    } else if (pfsMethod == "manualentry") {
      selectedApplicationFlow = "Manually";
    } else if (pfsMethod == "thirdparty") {
      selectedApplicationFlow = "3rdParty";
    }
    const reqObj = {
      Id: localStorage.getItem("Id"),
      ScreenName: "personalfinancialstatement",
      ApplicationId: localStorage.getItem("ApplicationId"),
      UpDoc_Personal_FinStatement_Path: getPathname(values.personalFinancial),
      UpDoc1_Patriot_Act_Form_Applicant_Path: getPayloadPaths(
        multiFilePaths.patriotApplicant
      ),
      UpDoc2_Patriot_Act_Form_CoBorrower_Path_2: getPayloadPaths(
        multiFilePaths.patriotCoBorrower
      ),
      UpDoc_Credit_Breau_Report_Path: getPathname(values.creditBureau),
      UpDoc3_Credit_Bureau_Report_CBR: getPathname(values.creditBureauCoBorrower),
      UpDoc3_FirstTwo_Pages_Tax_Return_Path: getPayloadPaths(
        multiFilePaths.taxReturn
      ),
      UpDoc_Capital_Account_Statements: getPayloadPaths(
        multiFilePaths.updoccapitalaccountstatements
      ),

      UpDoc_Liquidity_Statements: getPayloadPaths(
        multiFilePaths.updocliquiditystatements
      ),
      //CBRScore: values.creditBureauScore,
      ApplicationFlowType: selectedApplicationFlow,
      IsDocumentUploadCompleted: true,
    };

    setLoading(true);
    try {
      const response =
        await _NewapplicationService.submitApplicantData(reqObj);
      if (response.data.IsSuccess) {
        message.success(response.data.Message || "Upload Successful");
        if (pfsMethod == "pdfupload") {
          history.push({ pathname: routes.uploaddocumentpreview.path, state: { selectedDocumentOption: pfsMethod } });
          getApplicantDetailsByID();
        } else {
          if (isFromDashboard) {
            history.push({
              pathname: routes.dashboard.path,
              state: { appObjId, activeKey: tabActiveKey },
            });
          } else {
            history.push(routes.incomeSources.path);
            getApplicantDetailsByID();

          }
        }
        // notification.success({
        //   message: "Upload Successful",
        //   description: response.data.Message,
        //   icon: <CheckCircleOutlined style={{ color: "#52c41a" }} />,
        //   duration: 3,
        //   placement: "top",
        // });
      } else {
        // message.error(response.data.Message || COMMON_ERROR_MSG);
        // notification.error({
        //   message: "Upload Failed",
        //   description: response.data.Message,
        //   icon: <CloseCircleOutlined style={{ color: "#ff4d4f" }} />,
        //   duration: 3,
        //   placement: "top",
        // });
        if (response?.data?.Message) {
          notification.error({
            message: 'Error',
            description: (
              <div
                className="notification-content"
                dangerouslySetInnerHTML={{
                  __html: convertPTagsToBullets(response?.data?.Message),
                }}
              />
            ),
            duration: 0,
            placement: 'top',
            closable: true,
            className: 'centered-notification',
          });
        } else {
          message.error(COMMON_ERROR_MSG);
        }
      }
    } catch (e) {
      message.error("Something went wrong. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  const onBack = () => {
    if (isFromDashboard) {
      history.push({
        pathname: routes.dashboard.path,
        state: { appObjId, activeKey: tabActiveKey },
      });
    } else {
      if ((APPLICATION_TYPE_ID == "1" || APPLICATION_TYPE_ID == "3")) {
        history.push(routes.applicantsIdentification.path);
      } else if (APPLICATION_TYPE_ID == "4") {
        history.push(routes.identificationOfcoBorrower.path);
      } else if (APPLICATION_TYPE_ID == "2") {
        history.push(routes.ProofOfTrust.path);
      } else if (APPLICATION_TYPE_ID == "5") {
        history.push(routes.ApplicantsDetails.path);
      } 
      else {
        console.log("");
      }
    }
  };
  const mapApplicationFlowTypeToPfsMethod = (value) => {
    if (!value) return null;

    const map = {
      upload: "pdfupload",
      manually: "manualentry",
      "3rdparty": "thirdparty",
    };

    return map[value.toLowerCase()] || null;
  };
  const getApplicantDetailsByID = async () => {
    try {
      setLoading(true);
      const res =
        await _NewapplicationService.getApplicantInformationByApplicationId(
          isFromDashboard ? appObjId : localStorage.getItem("Id")
        );
      if (res.data) {
        const resObj = res.data;
        setApplInfo(resObj);
        setPfsMethod(
          mapApplicationFlowTypeToPfsMethod(resObj.ApplicationFlowType)
        );
        setApiPfsMethod(mapApplicationFlowTypeToPfsMethod(resObj.ApplicationFlowType));
        setApiPfsMethodLable(resObj.ApplicationFlowType)
        localStorage.setItem("applicationFlowType", resObj.ApplicationFlowType);
        const infoObj = {
          personalFinancial: resObj.UpDoc_Personal_FinStatement_Path,
          patriotApplicant:
            resObj.UpDoc1_Patriot_Act_Form_Applicant_Path,
          patriotCoBorrower:
            resObj.UpDoc2_Patriot_Act_Form_CoBorrower_Path_2,
          creditBureau: resObj.UpDoc_Credit_Breau_Report_Path,
          creditBureauCoBorrower:
            resObj.UpDoc3_Credit_Bureau_Report_CBR,
          taxReturn:
            resObj.UpDoc3_FirstTwo_Pages_Tax_Return_Path,
          updoccapitalaccountstatements: resObj.UpDoc_Capital_Account_Statements,
          updocliquiditystatements: resObj.UpDoc_Liquidity_Statements,

          // creditBureauScore: resObj.CBRScore,
        };

        // getApplicantInformationByApplicationId already returns each of these 5 fields as
        // comma-separated SAS-SIGNED URLs (see ApplicantService.cs, GenerateMultipleSasUrl). Keep that
        // signed value (*Raw) for the clickable download link, and a separate SAS-stripped bare path
        // (via getRelativePath) only for internal bookkeeping (rowId numbering, the Save payload) --
        // never use the stripped path as a download link, Azure Blob Storage rejects it unsigned.
        const capitalFilesRaw =
          resObj.UpDoc_Capital_Account_Statements?.split(",")?.filter(Boolean) || [];
        const capitalFiles = capitalFilesRaw.map(getRelativePath);

        const liquidityFilesRaw =
          resObj.UpDoc_Liquidity_Statements?.split(",")?.filter(Boolean) || [];
        const liquidityFiles = liquidityFilesRaw.map(getRelativePath);

        const patriotApplicantFilesRaw =
          resObj.UpDoc1_Patriot_Act_Form_Applicant_Path?.split(",")?.filter(Boolean) || [];
        const patriotApplicantFiles = patriotApplicantFilesRaw.map(getRelativePath);

        const patriotCoBorrowerFilesRaw =
          resObj.UpDoc2_Patriot_Act_Form_CoBorrower_Path_2?.split(",")?.filter(Boolean) || [];
        const patriotCoBorrowerFiles = patriotCoBorrowerFilesRaw.map(getRelativePath);

        const taxReturnFilesRaw =
          resObj.UpDoc3_FirstTwo_Pages_Tax_Return_Path?.split(",")?.filter(Boolean) || [];
        const taxReturnFiles = taxReturnFilesRaw.map(getRelativePath);

        const maxCapitalRowId = getMaxRowIdFromUrls(capitalFiles);
        const maxLiquidityRowId = getMaxRowIdFromUrls(liquidityFiles);
        const maxPatriotApplicantRowId = getMaxRowIdFromUrls(patriotApplicantFiles);
        const maxPatriotCoBorrowerRowId = getMaxRowIdFromUrls(patriotCoBorrowerFiles);
        const maxTaxReturnRowId = getMaxRowIdFromUrls(taxReturnFiles);

        const maxExistingRowId = Math.max(
          maxCapitalRowId,
          maxLiquidityRowId,
          maxPatriotApplicantRowId,
          maxPatriotCoBorrowerRowId,
          maxTaxReturnRowId
        );

        // next upload should be +1 -- rowIdRef is shared across every multi-file field on this
        // screen, so it must account for the highest rowId already used by any of them.
        rowIdRef.current = maxExistingRowId + 1;

        setMultiFilePaths({
          updoccapitalaccountstatements: capitalFiles,
          updocliquiditystatements: liquidityFiles,
          patriotApplicant: patriotApplicantFiles,
          patriotCoBorrower: patriotCoBorrowerFiles,
          taxReturn: taxReturnFiles,
        });

        const toMultiFileListItems = (prefix, files, rawFiles) =>
          files.map((path, index) => ({
            uid: `${prefix}-${index + 1}`,
            rowId: index + 1,
            name: getFileNameFromUrl(path),
            status: "done",
            url: rawFiles[index] || path,
            path,
          }));

        setMultiFileList({
          updoccapitalaccountstatements: toMultiFileListItems("capital", capitalFiles, capitalFilesRaw),
          updocliquiditystatements: toMultiFileListItems("liquidity", liquidityFiles, liquidityFilesRaw),
          patriotApplicant: toMultiFileListItems("patriotApplicant", patriotApplicantFiles, patriotApplicantFilesRaw),
          patriotCoBorrower: toMultiFileListItems("patriotCoBorrower", patriotCoBorrowerFiles, patriotCoBorrowerFilesRaw),
          taxReturn: toMultiFileListItems("taxReturn", taxReturnFiles, taxReturnFilesRaw),
        });

        setApplicantInfo(infoObj);
        form.setFieldsValue(infoObj);

        const newFileList = {};
        Object.keys(infoObj).forEach((field) => {
          if (infoObj[field] && field !== "creditBureauScore") {
            newFileList[field] = [
              {
                uid: "-1",
                name: FIELD_LABELS[field] || field,
                status: "done",
                //url: `${APP_BLOB_ROOT}${infoObj[field]}`,
                url: `${infoObj[field]}`,
              },
            ];
          }
        });
        setFileList(newFileList);
      }
    } catch (e) {
      console.error(e);
    } finally {
      setLoading(false);
    }
  };

  const fetchPrepopulatedPatriotActPdf = async () => {
    try {
      const ApplicationId = isFromDashboard ? appObjId : localStorage.getItem("Id");
      const res = await _NewapplicationService.createPrepopulatedPDFforPatriotAct(ApplicationId);
      if (res?.data?.IsSuccess && res?.data?.Obj?.DocName) {
        // DocName is now a full blob-storage URL (with its own SAS token query string),
        // not a relative path -- no longer needs the API_HOST prefix.
        setPatriotActDownloadUrl(res.data.Obj.DocName);
      }
    } catch (e) {
      console.error("Patriot Act PDF generation error:", e);
    }
  };

  return (
    <Spin spinning={loading || uploading}>
      <LeftLayout>
        {/* {applicationId && applicationId !== 'undefined' && applicationId !== 'null' && (
          <div style={{
            position: "absolute",
            top: 5,
            right: 20,
            margin: 0,
            zIndex: 1000,
            maxWidth: "1000px",
            padding: "8px 16px",
          }}>
            <ApplicationProgressBar />
            <Title level={3} style={{ margin: 0 }}>
              <ShowApplicationId />
            </Title>
          </div>
        )} */}
        <div>
          {applicationId && applicationId !== 'undefined' && applicationId !== 'null' && (
            <div>
              <ApplicationProgressBar />
              <Title level={5}>
                {/* <ShowApplicationId /> */}
              </Title>
            </div>
          )}
        </div>

        <Row className="rightbox upload_documentpage" style={{ minHeight: "100vh" }}>
          <Col span={24}>
            <Title className="mt50" level={3} style={{ marginBottom: 30 }}>
              Document Upload
            </Title>
            <Form
              form={form}
              layout="vertical"
              onFinish={onFinish}
              initialValues={{
                ...applicantInfo,
                pfsMethod: pfsMethod,
              }}
            >
              <Row gutter={[0, 24]} className="document-upload-wrapper">
                <Col span={24}>
                  <div className="doc-card upload-section-container">
                    <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
                      <div className="doc-card-title mb20">Financial Information <span className="required-tag">*</span> </div>
                      {apiPfsMethodLable && (
                        <div>
                          <span style={{ color: "white" }}>
                            Application Flow Type:{" "}
                            {apiPfsMethodLable === "Upload"
                              ? "Upload PFS"
                              : apiPfsMethodLable === "Manually"
                                ? "Complete Manually"
                                : apiPfsMethodLable}
                          </span>
                        </div>
                      )}
                    </div>
                    <div className="doc-card-header">

                      <Form.Item
                        className="pfsMethodFormItem"
                        name="pfsMethod"
                        rules={[
                          { required: true, message: "Application Flow type is required" },
                        ]}

                      >

                        <Radio.Group
                          value={pfsMethod}
                          disabled={!!apiPfsMethod}
                          onChange={(e) => {
                            handlePfsMethodChange(e);
                            form.setFieldsValue({ pfsMethod: e.target.value });
                          }}
                          className="pfs-method-selector"
                        >
                          <Radio.Button value="pdfupload">
                            Upload PFS
                          </Radio.Button>

                          <Radio.Button value="manualentry">
                            Complete Manually
                          </Radio.Button>

                          {/* <Radio.Button disabled value="thirdparty">
                            Use 3rd Party
                          </Radio.Button> */}
                        </Radio.Group>
                      </Form.Item>
                    </div>

                  </div>
                </Col>
                {pfsMethod == "pdfupload" && (
                  <Col span={24}>
                    <div className="doc-card">

                      <div className="doc-card-header">
                        <div>
                          {/* <div className="doc-card-title">Upload PFS</div> */}
                          <div className="doc-card-title">Upload PFS <span className="required-tag">*</span></div>
                          <div className="doc-card-helper">
                            Format : PDF Only, Size Up to 25MB.
                          </div>

                          {/* <div className="doc-card-subtitle">
                          Personal Financial Statement
                        </div> */}
                        </div>

                        <Button
                          type="link"
                          icon={<DownloadOutlined />}
                          className="doc-download-btn"
                          href={preUploadedPfsUrl}
                          target="_blank"
                        >
                          Download PFS Template
                        </Button>
                      </div>

                      <div className="doc-upload-box">
                        {getUploadPFSItem(
                          "Personal Financial Statement",
                          "personalFinancial",
                          "personalfinancialstatement"
                        )}
                      </div>
                    </div>
                  </Col>
                )}
                {/* <Col span={24}>
                  <div className="doc-card">
                    <div className="doc-card-header">
                      <div>
                        <div className="doc-card-title">Personal Financial Statement</div>
                        <div className="doc-card-subtitle">
                          Personal Financial Statement
                        </div>
                      </div>

                      <Button
                        type="link"
                        icon={<DownloadOutlined />}
                        className="doc-download-btn"
                        href="blank.pdf"
                        target="_blank"
                      >
                        Download Personal Financial Statement
                      </Button>
                    </div>

                    <div className="doc-upload-box">
                      {getUploadItem(
                        "Personal Financial Statement",
                        "personalFinancial",
                        "personalfinancialstatement"
                      )}
                    </div>
                  </div>
                </Col> */}
                <Col span={24}>
                  <div className="doc-card">
                    <div className="doc-card-header">
                      <div>
                        <div className="doc-card-title">Patriot Act Form</div>
                        <div className="doc-card-subtitle">
                          Patriot Act Form (Client) <span className="required-tag">*</span>
                        </div>
                        <div className="doc-card-helper">
                          Format : PDF Only, Size Up to 25MB.
                        </div>
                      </div>

                      <Button
                        type="link"
                        icon={<DownloadOutlined />}
                        className="doc-download-btn"
                        href={patriotActDownloadUrl}
                        target="_blank"
                      >
                        Download Patriot Act Form
                      </Button>
                    </div>

                    <div className="doc-upload-box">
                      {getMultiUploadItem(
                        "Patriot Act Form (Applicant)",
                        "patriotApplicant",
                        "updoc1_patriot_act_form_applicant"
                      )}
                    </div>

                    {APPLICATION_TYPE_ID == "4" && (
                      <div className="doc-upload-box mt15">
                        <div className="doc-card-subtitle mb10">
                          Patriot Act Form (Co-Borrower) <span className="required-tag">*</span>
                        </div>
                        <div className="doc-card-helper mb10">
                          Format : PDF Only, Size Up to 25MB.
                        </div>
                        {getMultiUploadItem(
                          "Patriot Act Form (Co-Borrower)",
                          "patriotCoBorrower",
                          "updoc1_patriot_act_form_coborrower"
                        )}
                      </div>
                    )}
                  </div>
                </Col>

                {false && (
                  <Col span={24}>
                    <div className="doc-card">
                      <div className="doc-card-title">Credit Bureau Report</div>

                      <div className="doc-upload-box">
                        <div className="doc-card-subtitle mb10">
                          Credit Bureau Report (Client)
                        </div>
                        <div className="doc-card-helper mb10">
                          Format : PDF Only, Size Up to 25MB.
                        </div>
                        {getUploadItem(
                          "Credit Bureau Report",
                          "creditBureau",
                          "credit_bureau_report",
                          false
                        )}
                      </div>

                      {APPLICATION_TYPE_ID == "4" && (
                        <div className="doc-upload-box mt15">
                          <div className="doc-card-subtitle mb10">
                            Credit Bureau Report (Co-Borrower)<span className="required-tag"> * </span>
                          </div>
                          <div className="doc-card-helper mb10">
                            Format : PDF Only, Size Up to 25MB.
                          </div>
                          {getUploadItem(
                            "Credit Bureau Report (Co-Borrower)",
                            "creditBureauCoBorrower",
                            "updoc3_credit_bureau_report_cbr"
                          )}
                        </div>
                      )}
                    </div>
                  </Col>
                )}{/* Tax Return */}
                <Col span={24}>
                  <div className="doc-card">
                    <div className="doc-card-title">Tax Return</div>

                    <div className="doc-upload-box">
                      <div className="doc-card-subtitle mb10">
                        First Two Pages Of Personal Tax Return <span className="required-tag">*</span>
                      </div>
                      <div className="doc-card-helper mb10">
                        Format : PDF Only, Size Up to 25MB.
                      </div>

                      {getMultiUploadItem(
                        "First Two Pages Of Personal Tax Return",
                        "taxReturn",
                        "updoc1_firsttwo_pages_join_tax_return"
                      )}
                    </div>
                  </div>
                </Col>

                <Col span={24}>
                  <div className="doc-card">
                    <div className="doc-card-title">Capital Account Statements</div>
                    <div className="doc-upload-box">
                      <div className="doc-card-helper mb10">
                        Format : PDF & Excel Only
                      </div>

                      {getMultiUploadItem(
                        "Capital Account Statements",
                        "updoccapitalaccountstatements",
                        "updoccapitalaccountstatements"
                      )}
                    </div>
                  </div>
                </Col>

                <Col span={24}>
                  <div className="doc-card">
                    <div className="doc-card-title">Liquidity Statements</div>
                    <div className="doc-upload-box">
                      <div className="doc-card-helper mb10">
                        Format : PDF & Excel Only.
                      </div>

                      {getMultiUploadItem(
                        "Liquidity Statements",
                        "updocliquiditystatements",
                        "updocliquiditystatements"
                      )}
                    </div>
                  </div>
                </Col>
              </Row>
              {/* <Form.Item
                label="CBR Score"
                name="creditBureauScore"
                rules={[{ required: true, message: "CBR Score is required" },
                {
                  validator: (_, value) => {
                    // if (value === undefined || value === '') {
                    //   return Promise.reject(new Error("CBR Score is required"));
                    // }
                    const num = Number(value);
                    if (!Number.isInteger(num)) {
                      return Promise.reject(new Error("Enter a valid integer"));
                    }
                    if (num < 0 || num > 850) {
                      return Promise.reject(new Error("CBR Score must be between 0 and 850"));
                    }
                    return Promise.resolve();
                  },
                },
                ]}
                className="mt50"
              >
                <IntegerInput
                  className="w300"
                  maxLength={3}
                  placeholder="Enter CBR Score"
                />
              </Form.Item> */}

              {/* <Form.Item>
                <div
                  style={{
                    display: "flex",
                    gap: 16,
                    marginTop: 10,
                  }}
                >
                  <ButtonComponent
                    onClick={onBack}
                    text="Go Back"
                    type="default"
                  />
                  <ButtonComponent
                    type="primary"
                    htmlType="submit"
                    // disabled={![1,2,4,9].includes(applInfo && applInfo.Application_Status_Id) ? true : false}
                    text="Save And Proceed"
                  />

                </div>
              </Form.Item> */}

              <Form.Item className="mt10">
                <Row gutter={16}>
                  <Col>
                    <ButtonComponent
                      onClick={onBack}
                      text="Go Back"
                      type="default"
                    />
                  </Col>
                  <Col>
                    <ButtonComponent
                      type="primary"
                      disabled={![1, 2, 4, 9].includes(applInfo && applInfo.Application_Status_Id) ? true : false}
                      text={
                        <span>
                          Save And Proceed <ArrowRightOutlined />
                        </span>
                      }
                      onClick={() => {
                        form.validateFields()
                          .then(() => {
                            signatureForm.resetFields();
                            setIsSignatureModalOpen(true);
                          })
                          .catch(() => { });
                      }}
                    />
                  </Col>
                </Row>
              </Form.Item>
            </Form>
          </Col>
        </Row>
      </LeftLayout>

      <Modal
        title="Certification"
        open={isSignatureModalOpen}
        width={820}
        centered
        okText={<span id="yesBtn">Submit</span>}
        cancelText={<span id="noBtn">Cancel</span>}
        okType="primary"
        onOk={() => {
          signatureForm.validateFields()
            .then(() => {
              setIsSignatureModalOpen(false);
              signatureForm.resetFields();
              form.submit();
            })
            .catch(() => { });
        }}
        onCancel={() => {
          setIsSignatureModalOpen(false);
          signatureForm.resetFields();
        }}
      >
        <div style={{ marginBottom: 16, color: 'rgba(244,244,245,0.85)' }}>
          <div style={{ fontWeight: 600, marginBottom: 8, color: 'rgba(244,244,245,0.85)' }}>By confirming below, I certify the following:</div>
          <ol style={{ paddingLeft: 20, margin: 0, lineHeight: '1.8', color: 'rgba(244,244,245,0.75)' }}>
            <li>The information contained in this Personal Financial Statement is true, complete, and accurate as of the Statement Date listed above.</li>
            <li>I authorize Levridge and any participating lender to verify any information provided herein, including through credit reports, employment verification, and third-party financial institutions.</li>
            <li>I understand that this statement is being provided in connection with a loan request, and that any material misrepresentation may result in denial of credit and may be subject to applicable laws.</li>
            <li>I agree to notify Levridge promptly of any material adverse change in my financial condition between the date of this statement and the date any credit is extended or renewed.</li>
            <li>I authorize Levridge to retain a copy of this statement in its records, subject to Levridge's confidentiality and privacy practices.</li>
          </ol>
        </div>
        <Form form={signatureForm} layout="vertical">
          <Row gutter={[16, 0]}>
            <Col xs={24} sm={8}>
              <Form.Item
                label="Applicant Name"
                name="applicantName"
                rules={[{ required: true, message: "Applicant Name is required" }]}
              >
                <Input placeholder="Enter Applicant Name" />
              </Form.Item>
            </Col>
            <Col xs={24} sm={8}>
              <Form.Item
                label="Applicant Date"
                name="applicantDate"
                rules={[{ required: true, message: "Applicant Date is required" }]}
              >
                <DatePicker style={{ width: "100%" }} format="MM/DD/YYYY" placeholder="Select Date" />
              </Form.Item>
            </Col>
            <Col xs={24} sm={8}>
              <Form.Item
                label="Title"
                name="title"
                rules={[{ required: true, message: "Title is required" }]}
              >
                <Input placeholder="Enter Title" />
              </Form.Item>
            </Col>
          </Row>
           {/* <Divider className="divider" /> */}
          {APPLICATION_TYPE_ID == "4" && (
            <>
              <div style={{ marginBottom: 12, color: "rgba(244,244,245,0.7)" }}>
                Co-Applicant (if applicable)
              </div>
              <Row gutter={[16, 0]}>
                <Col xs={24} sm={8}>
                  <Form.Item
                    label="Co-Applicant Name"
                    name="coApplicantName"
                    rules={[{ required: true, message: "Co-Applicant Name is required" }]}
                  >
                    <Input placeholder="Enter Co-Applicant Name" />
                  </Form.Item>
                </Col>
                <Col xs={24} sm={8}>
                  <Form.Item
                    label="Co-Applicant Date"
                    name="coApplicantDate"
                    rules={[{ required: true, message: "Co-Applicant Date is required" }]}
                  >
                    <DatePicker style={{ width: "100%" }} format="MM/DD/YYYY" placeholder="Select Date" />
                  </Form.Item>
                </Col>
                <Col xs={24} sm={8}>
                  <Form.Item
                    label="Relationship to Applicant"
                    name="relationshipToApplicant"
                    rules={[{ required: true, message: "Relationship to Applicant is required" }]}
                  >
                    <Input placeholder="Enter Relationship to Applicant" />
                  </Form.Item>
                </Col>
              </Row>
            </>
          )}
          <Form.Item
            name="certifyConfirm"
            valuePropName="checked"
            className="mt20"
            rules={[
              {
                validator: (_, value) =>
                  value
                    ? Promise.resolve()
                    : Promise.reject(new Error("Please confirm the certification to proceed")),
              },
            ]}
          >
            <Checkbox>
              I certify that the information provided is true, complete, and accurate, and I authorize Levridge to verify and retain it per its confidentiality practices.
            </Checkbox>
          </Form.Item>
        </Form>
      </Modal>
    </Spin>
  );
};

export default UploadDocumentsOne; 